<template>
  <div class="person-badge">
    <b-avatar class="ml-2 round-badge initials" :text="initials" />
    <div class="names">
      <div class="person-name">
        {{ fullName }}
      </div>
      <div v-if="companyName" class="company-name">
        {{ companyName }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PersonBadge',

  props: {
    person: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters(['personName', 'getCompany']),

    companyId() {
      return this.person && this.person.companyId;
    },

    personId() {
      return this.person && (this.person.personId || this.person._id);
    },

    company() {
      return this.person && this.person.companyId ? this.getCompany(this.person.companyId) : null;
    },

    companyName() {
      return this.company && this.company.companyName;
    },

    fullName() {
      let fullName;
      if (this.personId) {
        fullName = this.personName(this.personId);
      }

      if (!fullName && this.person) {
        fullName = this.person.name || [this.person.firstName, this.person.lastName].filter(Boolean).join(' ');
      }

      return (fullName && fullName.trim()) || '?';
    },

    initials() {
      return this.fullName
        ? this.fullName
            .split(' ', 2)
            .map((str) => str[0] || '')
            .join('')
        : '?';
    },
  },
};
</script>

<style scoped>
.person-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.names {
  width: 100%;
  padding: 0px 0px 0px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-name {
  font-weight: light;
  font-size: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.round-badge {
  background-color: #2e8ab2;
  color: white;
}

.initials {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/PersonBadge.vue